module.exports = __webpack_public_path__ + "static/media/google-play.b781ce9f.png";